import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import { Container, SectionHeading, SectionKicker, TricolourRibbon } from '@/components/common/Layout';
import { DashboardPreview, DashboardLeaderboard } from '@/components/sections/DashboardPreview';
import { Card, CardContent } from '@/components/ui/card';
import { BadgeCheck, Clock } from 'lucide-react';

export default function DashboardPage() {
  const { t } = useLang();
  return (
    <div>
      <section className="hero-surface">
        <Container className="py-14 sm:py-16">
          <SectionKicker>{t('nav.dashboard')}</SectionKicker>
          <h1 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0B1220]">
            {t('dashboard.title')}
          </h1>
          <p className="mt-4 max-w-3xl text-[#5B6B82] text-base leading-relaxed">{t('dashboard.lede')}</p>
        </Container>
      </section>

      <section className="py-14">
        <Container>
          <DashboardPreview />
        </Container>
      </section>

      <section className="py-10 bg-white border-y border-[#D7E1EF]">
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-span-8">
              <SectionHeading title={t('dashboard.leaderboard_h')} subtitle={t('dashboard.leaderboard_sub')} />
              <div className="mt-6">
                <DashboardLeaderboard />
              </div>
            </div>
            <aside className="lg:col-span-4">
              <Card className="border-[#D7E1EF] bg-[#F5F8FC]">
                <CardContent className="p-6">
                  <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[#062B5C]">
                    {t('dashboard.methodology_h')}
                  </div>
                  <p className="mt-3 text-sm text-[#0B1220] leading-relaxed">{t('dashboard.methodology_p')}</p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-[#5B6B82]">
                    <Clock className="h-3.5 w-3.5" /> {t('dashboard.cadence')}
                  </div>
                  <div className="mt-2 flex items-center gap-2 text-xs text-[#138A4B]">
                    <BadgeCheck className="h-3.5 w-3.5" /> {t('common.illustrative')}
                  </div>
                </CardContent>
              </Card>

              <Card className="mt-6 border-[#D7E1EF] bg-white">
                <CardContent className="p-6">
                  <div className="text-xs font-semibold uppercase tracking-[0.14em] text-[#062B5C]">
                    {t('dashboard.trust_h')}
                  </div>
                  <p className="mt-3 text-sm text-[#0B1220] leading-relaxed">{t('dashboard.trust_p')}</p>
                </CardContent>
              </Card>
            </aside>
          </div>
        </Container>
      </section>

      <TricolourRibbon />
    </div>
  );
}
